import { Tag } from "antd";
import { AppleFilled } from "@ant-design/icons";

export const AppleTag = () => {
  return (
    <Tag color="#000000" className="m-1 w-[75px]" icon={<AppleFilled />}>
      Apple
    </Tag>
  );
};
